import { FC } from 'react';
import { Button, } from '@mui/material';

import ModalDialog from "./ModalDialog";
import { useConfirm } from '../../hooks/PopupContext';

const ConfirmModal: FC<void> = () => {
  const { onConfirm, onCancel, confirmState } = useConfirm();
  const onClose = (id: string) => {
    if (id === 'sys-close') {
      onCancel();
    }
  }
  return (
    <ModalDialog
      open={confirmState.show}
      title={confirmState.title}
      content={
        confirmState.content
      }
      buttons={
        <>
          <Button variant="outlined" onClick={onCancel}>No</Button>
          <Button color="primary" onClick={onConfirm} variant="contained" >
            Yes
          </Button>
        </>
      }
      onClose={onClose}
      sxx={{ minHeight: 120, minWidth: 360 }}
    />
  );
};

export default ConfirmModal;